module.exports = __webpack_public_path__ + "static/media/vecteezy_logo_icon.90795b8c.jpg";